import { FormattedMessage } from 'react-intl';

import ImageEmptyState from '../../assets/images/managed-empty-state.png';
import { EXTERNAL_LINKS } from '../../routes';
import { trackingParams } from '../../utils/tracking';

import * as Styled from './empty-state.style';

export const EmptyState: React.FC = () => {
  return (
    <Styled.EmptyStateCard>
      <Styled.TextLayer>
        <Styled.Headline size="xxlarge">
          <FormattedMessage id="CP_EMPTY_STATE_MANAGED_HEADER" />
        </Styled.Headline>
        <Styled.BodyCopy>
          <FormattedMessage id="CP_EMPTY_STATE_MANAGED_SUBHEADER" />
        </Styled.BodyCopy>
        <div>
          <Styled.BaseButton
            href={EXTERNAL_LINKS.newCompany}
            trackingAttributes={trackingParams.createProfile}
            size="small"
            variant="secondary"
          >
            <FormattedMessage id="CP_EMPTY_STATE_MANAGED_BUTTON" />
          </Styled.BaseButton>
        </div>
      </Styled.TextLayer>
      <Styled.Image src={ImageEmptyState} alt="" />
    </Styled.EmptyStateCard>
  );
};
